<div class="alert alert-primary" role="alert" [ngClass]="{'transparent': !message || message === ''}">
    {{message}}
</div>